/**
 * Campos auditáveis de uma venda — subconjunto dos campos de negócio
 * que têm relevância para rastreabilidade. Exclui metadados internos
 * (created_at, updated_at, company_id) e PII sensível.
 */
export const AUDITABLE_SALE_FIELDS = [
  'total_value',
  'status',
  'discount_percentage',
  'discount_value',
  'freight_value',
  'payment_conditions',
  'notes',
  'salesperson_id',
  'delivery_date',
  'delivery_address',
] as const;

/**
 * Campos auditáveis de um orçamento.
 */
export const AUDITABLE_QUOTATION_FIELDS = [
  'total_value',
  'status',
  'discount_percentage',
  'discount_value',
  'notes',
  'valid_until',
  'salesperson_id',
] as const;

export interface DiffEntry {
  field: string;
  from: unknown;
  to: unknown;
}

/**
 * Compara dois snapshots de um registro e retorna apenas os campos
 * cujos valores mudaram.
 *
 * @param before  Estado anterior do registro
 * @param after   Estado posterior do registro
 * @param fields  Lista de campos a comparar (apenas esses são incluídos)
 */
export function buildDiff(
  before: Record<string, unknown>,
  after: Record<string, unknown>,
  fields: readonly string[]
): DiffEntry[] {
  return fields
    .filter((f) => {
      const bVal = before[f];
      const aVal = after[f];
      // Comparação estrita; converte undefined para null para evitar
      // falsos positivos quando o campo simplesmente não existe no snapshot.
      const b = bVal === undefined ? null : bVal;
      const a = aVal === undefined ? null : aVal;
      return b !== a;
    })
    .map((f) => ({
      field: f,
      from: before[f] === undefined ? null : before[f],
      to:   after[f]  === undefined ? null : after[f],
    }));
}
